import initialState from '../initialstate';
import {get as _get} from 'lodash';
import {HttpStatusCodes} from '../../util/uiconstants';
import {GET_RISKS} from '../../actions/actiontypes';

export default function getRisksReducer(state = initialState.risks, action) {
	switch (action.type) {
		case GET_RISKS: {
			const status = _get(action, 'responseObj.status', null);
			if (status === HttpStatusCodes.Ok) {
				const data = _get(action, 'responseObj.data', []);
				return data;
			}
			return [];
		}
		default:
			return state;
	}
}